import { designTokens } from '../lib/design-tokens'
import type { TextLinkVariantConfig, TextLinkVariantId } from './text-link.types'

export const textLinkVariants: Record<TextLinkVariantId, TextLinkVariantConfig> = {
  primary: {
    size: 'md',
    underline: 'none',
    align: 'center',
    color: designTokens.colors.neutral.white,
    hoverColor: designTokens.colors.text.linkHover,
    pressedColor: designTokens.colors.text.linkPressed,
    lineHeight: 'normal',
    fontWeight: designTokens.typography.body.md.weight,
    fontFamily: designTokens.typography.fontFamilies.primary,
  },
}
